// Core
import styled, { css } from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

// Types
import { Theme } from '../../../../../../types/theme';

// Components
import { Col } from '../../../../../../layout/elements/Col';
import {
  StatusIndicatorProps,
  StatusIndicatorStatus,
} from '../../../../../../layout/elements/StatusIndicator';

/** Reusable styles */
const borderColor = (
  { theme }: { theme: Theme },
) => theme.color.crusherDashboard.lubricationUnitDrawer.borderColor;

const flexCenterBetween = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const OverallStatusContainer = styled.div`
  ${flexCenterBetween};
  border-bottom: 1px solid ${borderColor};
  padding: 0.75rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.1875rem 1.5rem;
  };
`;

export const LubeTankLevelContainer = styled.div`
  ${flexCenterBetween};
  padding: 0.75rem 1rem;
  border-bottom: 1px solid ${borderColor};

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.1875rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    border-bottom: none;
  };
`;

export const LubricationSupplyFlowContainer = styled.div`
  ${flexCenterBetween};
  padding: 0.75rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.1875rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    border-left: 1px solid ${borderColor};
  };
`;

export const RunningStatusContainer = styled.div`
  padding: 0.75rem 1rem;
  border-bottom: 1px solid ${borderColor};

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.125rem 1.25rem;
  };
`;

export const RunningStatusList = styled.ul`
  padding-left: 0;
  margin: 0;
  list-style: none;
`;

export const RunningStatusPermissive = styled.li<Pick<StatusIndicatorProps, 'status'>>`
  padding: 12px 0px 12px 14px;
  background-color: ${({ status, theme }) => (status !== StatusIndicatorStatus.alarm
    ? 'transparent'
    : theme.color.crusherDashboard.lubricationUnitDrawer.descriptionListErrorBackgroundColor
  )};
  border-radius: 4px;
  margin: 0 1rem 0 0.75rem;
`;

export const PermissiveTitleContainer = styled.div`
  padding: 0.75rem 1rem 0.625rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.125rem 1.25rem 0.625rem 1.25rem;
  };
`;

export const PermissiveItem = styled.li<Pick<StatusIndicatorProps, 'status'>>`
  padding: 12px 0px 12px 14px;
  background-color: ${({ status, theme }) => (status !== StatusIndicatorStatus.alarm
    ? 'transparent'
    : theme.color.crusherDashboard.lubricationUnitDrawer.descriptionListErrorBackgroundColor
  )};
  border-radius: 4px;
  margin: 0 1rem 0 0.75rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    margin: 0 1.25rem 0 1.5rem;
  };
`;

export const PermissiveListContainer = styled.ul<{
  borderBottom?: boolean,
}>`
  list-style: none;
  margin: 0;
  padding: 0 0 1.5rem 0;

  ${({ borderBottom }) => borderBottom && css`
    border-bottom: 1px solid ${borderColor};
  `};

  @media (min-width: ${BREAKPOINTS.xl}px) {
    height: 100%;
  };
`;

export const LubePermissivesContainer = styled.ul`
  list-style: none;
  padding: 0 0 1.5rem 0;
  margin: 0;

  @media (min-width: ${BREAKPOINTS.xl}px) {
    height: 100%;
    border-left: 1px solid ${borderColor};
  };
`;

export const ThermometerContainer = styled(Col)<{ divider?: boolean }>`
  border-right: ${({ divider, theme }) => (
    divider
      ? `1px solid ${borderColor({ theme })}`
      : 'none'
  )};
  border-top: 1px solid ${borderColor};
  padding: 0.75rem 0;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.1875rem 0;
  };
`;

export const LubricationContainer = styled.div`
  border: 1px solid ${borderColor};
  border-radius: 4px;
`;

export const BorderBottomContainer = styled.div`
  border-bottom: 1px solid ${borderColor};
`;

export const WinterModeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-top: 1px solid ${borderColor};

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.5rem;
  };
`;

export const WinterModeStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    gap: 16px;
  };
`;
